import React from "react";
import { PopupModal } from "components/modals/ModalBox";
import useButtonLoader from "hooks/useButtonLoader";
import { toastMessage } from "utils/toastMessage";
import { deleteSelectedBrand } from "services/brand-management";
import { updateDeliveryStatusApi, deletedApi } from "services/masterApi";


const DeleteSlot = ({ show, data, close, listing }) => {
  const [bannerButtonLoader, setBannerButtonLoader] = useButtonLoader("Yes");

  const deleteBannerHandler = async () => {
    try {
      setBannerButtonLoader(true);
      const {
        data: { code, status, message },
      } = await deletedApi({id:data?._id});

      if (status || code === 200) {
        close();
        listing();
        toastMessage(message, "success", "DeleteSlot");
      }
    } catch (e) {
      console.log("error:", e);
    } finally {
      setBannerButtonLoader(false);
    }
  };

  return (
    <PopupModal
      show={show}
      handleClose={close}
      content="Are you sure you want to Delete this Slot?"
      title="Delete Slot"
      buttonLoader={bannerButtonLoader}
      action={deleteBannerHandler}
    />
  );
};

export default DeleteSlot;